import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const inp = "px-2.5 py-1.5 rounded border text-sm bg-transparent";
const DEF = { confirm_reminders_enabled: true, confirm_reminder_interval_hours: 12, confirm_reminder_max: 3, confirm_reminder_cutoff_hours: 2, confirm_reminder_form_slugs: ["t-t-road-to-sold-out"] };

const Num = ({ label, k, s, set, hint }) => (
  <label className="text-xs text-neutral-500 space-y-1">
    <div>{label}</div>
    <input type="number" min="0" className={`${inp} w-full`} value={s[k]} onChange={(e) => set({ [k]: e.target.value === "" ? "" : Number(e.target.value) })} data-testid={`confirm-${k}`} />
    {hint && <div className="text-[10px] text-neutral-600">{hint}</div>}
  </label>
);

export default function ConfirmReminders({ isAdmin }) {
  const [s, setS] = useState(null);
  const [slugs, setSlugs] = useState("");
  useEffect(() => {
    api.get("/crm/config").then((r) => {
      const v = Object.fromEntries(Object.entries(DEF).map(([k, d]) => [k, r.data[k] ?? d]));
      setS(v); setSlugs(v.confirm_reminder_form_slugs.join(", "));
    });
  }, []);
  if (!s) return null;
  const set = (p) => setS((x) => ({ ...x, ...p }));
  const save = async () => {
    try {
      await api.put("/crm/config", { ...s, confirm_reminder_form_slugs: slugs.split(",").map((x) => x.trim()).filter(Boolean) });
      toast.success("Confirm reminders saved");
    } catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
  };
  return (
    <div className="panel p-4 space-y-3" data-testid="confirm-reminders-settings">
      <div className="text-sm font-medium">Meeting confirmation reminders</div>
      <div className="text-xs text-neutral-500">Emails the lead from the host's Gmail with Confirm / Reschedule / Cancel buttons until they confirm. Separate from the 24h / 1h reminders.</div>
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" disabled={!isAdmin} checked={!!s.confirm_reminders_enabled} onChange={(e) => set({ confirm_reminders_enabled: e.target.checked })} data-testid="confirm-enabled" />On</label>
      <div className="grid grid-cols-3 gap-3">
        <Num label="Every (hours)" k="confirm_reminder_interval_hours" s={s} set={set} />
        <Num label="Max reminders" k="confirm_reminder_max" s={s} set={set} hint="0 = no cap" />
        <Num label="Stop when meeting is within (hours)" k="confirm_reminder_cutoff_hours" s={s} set={set} />
      </div>
      <label className="block text-xs text-neutral-500 space-y-1">
        <div>Forms (slugs, comma separated)</div>
        <input className={`${inp} w-full`} value={slugs} onChange={(e) => setSlugs(e.target.value)} data-testid="confirm-form-slugs" />
      </label>
      {isAdmin && <button className="btn" onClick={save} data-testid="confirm-save">Save</button>}
    </div>
  );
}
